import { render } from "./ProductionDocument.vue?vue&type=template&id=7b078936"
import script from "./ProductionDocument.vue?vue&type=script&lang=js"
export * from "./ProductionDocument.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__